import AppRecord from './AppRecord.js'

class EntityCostType extends AppRecord {
}

export default EntityCostType